import React, { useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import { useMutation, useQuery } from "react-query";
import {
  getRewards,
  getRewardsDashboard,
  getRewardsredemption,
  getRewardsStats,

} from "../../../MyApi/rewards";
import { getCountriesUser } from "../../../MyApi/admin/countries/countries";
import StatsCard from "../../../Components/UI/staticsCard";
import {
  exchangeColumns,
  exchangeStatsConfig,
} from "../config";
import WithdrawlModal from "../withdrawlmodal";
import DataTable from "../../../Components/UI/table/DataTable";
import FilterRewardsCard from "../../../Components/rewards/filter";

import { toast } from "react-toastify";
import TableActions from "../../../Components/UI/table/TableActions";
import StatusBadge from "../../../Components/UI/statusBadge";
import { formatPrice } from "../../../utils/formatPrice";

const ExchangePage = () => {
  const [activeTab, setActiveTab] = useState("points");
  const [modalMode, setModalMode] = useState("add");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRewardId, setSelectedRewardId] = useState(null);

  // Filter state
  const [filterState, setFilterState] = useState({
    search: "",
    countryId: "",
  });

  // Countries query
  const { data: countriesData, isLoading: countriesLoading } = useQuery(
    ["countries"],
    () => getCountriesUser(localStorage.getItem("i18nextLng")),
  );

  const countries = countriesData?.data?.countries || [];
  const { data: statsData, isLoading: isLoadingStats } = useQuery(
    "getStatsRewards",
    getRewardsStats,
  );
  const {
    data: dashData,
    isLoading,
    refetch,
    isFetching,
  } = useQuery("getRewardsDashboard", () => getRewardsDashboard());
  const {
    data: rewardData,
    isLoading: isLoadingReward,
    error: rewardsError,
  } = useQuery(["getRewards", currentPage, filterState], () =>
    getRewards({
      search: filterState.search,
      countryId: filterState.countryId,
    }),
  );

  const {
    data: redemptionData,
    isLoading: redemptionLoading,
    error: redemptionError,
  } = useQuery(["getRewardsredemption", currentPage, filterState], () =>
    getRewardsredemption({
      search: filterState.search,
      countryId: filterState.countryId,
    }),
  );
  const statics = statsData?.data?.stats || [];

  const rewards = rewardData?.data?.rewards || [];
  const totalItems = rewardData?.data?.pagination?.total || 0;
  const last_page = rewardData?.data?.pagination?.last_page || 0;
  const totalredemptions = redemptionData?.data?.pagination?.total || 0;
  const lastPageRedemptions = redemptionData?.data?.pagination?.last_page || 0;

  const redemption = redemptionData?.data?.redemption || [];

  const deleteRewardMutation = useMutation({
    mutationKey: ["deleteReward"],
    mutationFn: (rewardId) => {
      const axios = require("axios");
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng");
      return axios.delete(`/v1/admin/rewards/${rewardId}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
    },
    onSuccess: (data) => {
      toast.success(`${data.data.message}`);
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });


  const rewardsDashData =
    activeTab === "points"
      ? dashData?.data?.loyalty_reward || {}
      : activeTab === "orders_amout"
        ? dashData?.data.spending_reward || {}
        : {};

  const exchangeRewardStatics = exchangeStatsConfig(statics);
  const openModal = (mode, rewardId = null) => {
    setIsModalOpen(true);
    setModalMode(mode);
    setSelectedRewardId(rewardId);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRewardId(null);
  };

  const systemRewardsColumns = [
    {
      label: "المكافأه",
      render: (row) => <div>{row.title}</div>,
    },
    { label: "الوصف", accessor: "description" },
    {
      label: "القيمة",
      render: (row) => (
        <div>
          {row.type === "wallet"
            ? formatPrice(row.country.currency_factor, row.value_amount)
            : row.coupon.code}{" "}
        </div>
      ),
    },
    { label: "النوع", accessor: "type" },
    { label: "عدد النقاط", render: (row) => <div>{row.points_cost} </div> },
    { label: "مرات الإستخدام", accessor: "usage_count" },
    { label: " المرات المستخدمة", accessor: "count_of_use" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row?.is_active ? "active" : "inActive"} />
      ),
    },
    { label: "تاريخ الانتهاء", accessor: "end_date" },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          editPermission="update_reward"
          deletePermission="delete_reward"
          edit={() => openModal("edit", row.id)}
          deleteFn={(rewardId) => deleteRewardMutation.mutate(rewardId)}
          id={row.id}
          mutationKey={["deleteReward"]}
        />
      ),
    },
  ];


  // Filter handlers
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilterState((prev) => ({
      ...prev,
      search: value,
    }));
    setCurrentPage(1); // Reset to first page when filtering
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setFilterState((prev) => ({
      ...prev,
      countryId: value,
    }));
    setCurrentPage(1); // Reset to first page when filtering
  };

  return (
    <div>
      <HeaderBar
        title={"الأرباح"}
        content={"إدارة أرباح النظام، نقاط العملاء، وعمليات السحب والتبديل."}
      />
      {isModalOpen && (
        <WithdrawlModal
          isOpen={isModalOpen}
          modalId={selectedRewardId}
          toggle={closeModal}
          activeTab={activeTab}
          modalMode={modalMode}
          dashboardData={rewardsDashData}
        />
      )}
      <div className="row g-3 mt-3">
        {exchangeRewardStatics?.map((stat, index) => (
          <div className="col-md" key={index}>
            <StatsCard {...stat} isLoading={isLoadingStats} />
          </div>
        ))}
      </div>
      <FilterRewardsCard
        searchTerm={filterState.search}
        countryId={filterState.countryId}
        onSearchChange={handleSearchChange}
        onCountryChange={handleCountryChange}
        countries={countries}
        countriesLoading={countriesLoading}
      />
        <div className="mb-3">
          <DataTable
            columns={systemRewardsColumns}
            data={rewards}
            title={"مكافآت النظام  "}
            createPermission={"create_reward"}
            actionLabel={"اضافة مكافئة "}
            onAddClick={() => openModal("add")}
            emptyMessage="لا توجد بيانات  "
            isLoading={isLoadingReward}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalItems={totalItems}
            itemsPerPage={last_page}
            error={rewardsError}
            onRetry={() => refetch()}
          />
        </div>

        <DataTable
          columns={exchangeColumns}
          data={redemption}
          title={"عمليات التبديل"}
          emptyMessage="لا توجد بيانات  "
          isLoading={redemptionLoading}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalItems={totalredemptions}
          itemsPerPage={lastPageRedemptions}
        />

    </div>
  );
};

export default ExchangePage;
